import { Divider } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Diff, Hunk } from 'react-diff-view';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import FileIcon from './FileIcon';
import Tooltip from '@material-ui/core/Tooltip';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { ColorPalette } from '../../../themes/soho/ColorPalette';
import Link, { LinkProps } from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import ViewFileIcon from '@material-ui/icons/DescriptionOutlined';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: 16
    },
    fileIcon: {
      marginRight: 4
    },
    panelHeader: {
      padding: 16,
      justifyContent: 'space-between',
      alignItems: 'center',
      display: 'flex'
    },
    panelHeaderItemGroup: {
      alignItems: 'center',
      display: 'flex'
    },
    filenameWrapper: {
      alignItems: 'center',
      display: 'flex'
    },
    diffWrapper: {
      fontSize: 13,
      color: ColorPalette.$graphite10,
      backgroundColor: ColorPalette.$white
    },
    fileTypeChip: {
      marginRight: 8
    },
    viewFileButton: {
      marginRight: 8
    }
  })
);

interface Props {
  file: object
}

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <Link innerRef={ref as any} {...props} color="textPrimary" />
));

function DiffPanel(props: Props & RouteComponentProps<any>) {
  const { file } = props;
  const classes = useStyles({});

  return (
    <Paper className={classes.root}>
      <div className={classes.panelHeader}>
        <Tooltip title={file.actionName ? `Action: ${file.actionName}` : ''}>
          <div className={classes.filenameWrapper}>
            <FileIcon diffType={file.diffType} className={classes.fileIcon} />
            <Typography>{file.filePath ? `${file.filePath} / ` : ''}{file.filename}</Typography>
          </div>
        </Tooltip>
        <div className={classes.panelHeaderItemGroup}>
          {file.filename !== 'Workflow' && <Tooltip title="View File">
            <IconButton
              className={classes.viewFileButton}
              size="small"
              target="_blank"
              rel="noopener noreferrer"
              href={`/faro/decks/${file.deckName}?version=${encodeURIComponent(file.deckVersion)}&defaultShowFileBrowser=false${file.relativePath ? `&defaultSelectedFileName=${encodeURIComponent(file.relativePath)}` : ''}`}
              component={AdapterLink}>
              <ViewFileIcon />
            </IconButton>
          </Tooltip>}
          <Chip className={classes.fileTypeChip} size="small" variant="outlined" label={file.fileType} />
          {file.assigned && <Tooltip title="This file is assigned to you"><CheckIcon color="primary" /></Tooltip>}
        </div>
      </div>
      <Divider />
      <div className={classes.diffWrapper}>
        {file.diff.files.map(({ oldRevision, newRevision, type, hunks }) => (
          <Diff key={oldRevision + '-' + newRevision} viewType="unified" diffType={type} hunks={hunks} tokens={file.diff.tokens}>
            {hunks => hunks.map(hunk => <Hunk key={hunk.content} hunk={hunk} />)}
          </Diff>
        ))}
      </div>
    </Paper>
  );
};

export default withRouter(DiffPanel);
